<template>
  <ul class="list-unstyled mt-3 mb-4">
    <feature-entry>Nutzung für bis zu drei Webseiten</feature-entry>
    <feature-entry>Impressum: Analyse und Generator</feature-entry>
    <feature-entry>Datenschutzerklärung: Analyse und Generator</feature-entry>
    <feature-entry>Über 160 Drittdienste unterstützt</feature-entry>
    <feature-entry>Keine Quellenangabe für Rechtstexte erforderlich</feature-entry>
    <feature-entry>Analyse von bis zu 200 Unterseiten</feature-entry>
    <feature-entry>Update-Service</feature-entry>
    <hr class="p-0 my-4">
    <feature-entry>AGB für Onlineshop: Analyse und Generator</feature-entry>
    <feature-entry>Widerrufsbelehrung für Onlineshop: Analyse und Generator</feature-entry>
    <feature-entry>Rechtstexte auch in Englisch</feature-entry>
    <feature-entry>Monatlicher Re-Check</feature-entry>
    <feature-entry v-if="!yearly">
      Monatlich kündbar
    </feature-entry>
    <feature-entry v-else>
      Jährlich kündbar
    </feature-entry>
    <hr class="p-0 my-4">
    <feature-entry>Technischer Support</feature-entry>
    <feature-entry>Bei Abmahnung: Erstberatung durch Rechtsanwalt</feature-entry>
    <feature-entry>Sonderkonditionen bei unseren Partneranwälten</feature-entry>
  </ul>
</template>
<script>
export default {
  props: {
    yearly: {
      type: Boolean,
      required: false
    },
  }
}
</script>
